import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const reset = () => {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
    };

    const save = async () => {
        if (newPassword.length < 6) {
            toast.error("A nova senha precisa ter pelo menos 6 caracteres");
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error("As senhas não coincidem");
            return;
        }
        setBusy(true);
        try {
            await api.post("/auth/change-password", {
                current_password: currentPassword,
                new_password: newPassword,
            });
            toast.success("Senha atualizada com sucesso");
            reset();
            onOpenChange(false);
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Erro ao trocar senha");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
            <DialogContent data-testid="change-password-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <KeyRound className="h-5 w-5" /> Trocar minha senha
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <div>
                        <Label>Senha atual</Label>
                        <Input
                            type="password"
                            data-testid="change-password-current"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            className="mt-1.5"
                            autoFocus
                        />
                    </div>
                    <div>
                        <Label>Nova senha</Label>
                        <Input
                            type="password"
                            data-testid="change-password-new"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Mínimo 6 caracteres"
                            className="mt-1.5"
                        />
                    </div>
                    <div>
                        <Label>Confirmar nova senha</Label>
                        <Input
                            type="password"
                            data-testid="change-password-confirm"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="mt-1.5"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button>
                    <Button
                        onClick={save}
                        disabled={busy || !currentPassword || !newPassword || !confirmPassword}
                        className="bg-[#D96B43] hover:bg-[#C25933] text-white rounded-full"
                        data-testid="change-password-save"
                    >
                        Trocar senha
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
